/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Pick_Existing_LotInputs */

const vi_form_err_pick_existing_lot = /** @type {(inputs: Form_Err_Pick_Existing_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô có sẵn`)
};

/**

* @param {Form_Err_Pick_Existing_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_pick_existing_lot = /** @type {((inputs?: Form_Err_Pick_Existing_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Pick_Existing_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_pick_existing_lot(inputs)
});